import React, {useCallback, useContext} from 'react';
import classes from './CompletedMessage.module.pcss';
import {observer} from 'mobx-react';
import Heading from 'js/components/Common/Heading/Heading';
import Button from 'js/components/Common/Button/Button';
import LearningPathStore from 'js/store/LearningPathStore';
import {CommonContext} from 'js/context/CommonContext/CommonContext';
import parse from 'html-react-parser';


const BeforeCompletedMessage = ({left = 'auto', show = false, postId, group = false, message}) => {
    const {apiPath} = useContext(CommonContext);
    const acceptClickHandler = useCallback(async () => {
        const {lastClickedElement} = LearningPathStore || {};
        const faqListCopy = [...LearningPathStore.faqStatusList];
        const index = faqListCopy.findIndex(item => item.faq_id === lastClickedElement);
        if (index !== -1) {
            faqListCopy[index].status = true;
        } else {
            faqListCopy.push({
                // eslint-disable-next-line babel/camelcase
                faq_id: lastClickedElement,
                status: true
            });
        }
        LearningPathStore.faqStatusList = faqListCopy;
        LearningPathStore.lastClickedElement = '';

        await LearningPathStore.sentGRTag(postId, apiPath);
        return await fetch(`${apiPath}/graphql`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: `
					{
                        selfLearning {
                          sendCompleted(
                          check: ${true}, 
                          post_id: ${postId}, 
                          main_tab_id: "${LearningPathStore.activeMainTab}", 
                          filter_tab_id: "${LearningPathStore.activeFilterTab}", 
                          faq_id: "${lastClickedElement}") {
                            result
                          }
                        }
                    }
				`
            })
        });


    }, [apiPath, postId]);

    const closeCallback = useCallback(() => {
        LearningPathStore.lastClickedElement = '';
    }, []);

    return show ?
    <section style={{
        left
    }} className={`${classes.CompletedMessage} ${classes.BeforeCompletedMessage}`}>
        <Heading text={'You\'re about to complete the topic!'} type={'h6'}/>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        {parse(message || '')}
        <Button type={'button'} buttonType={'ButtonUncolored'} handler={() =>
            group ? LearningPathStore.checkAllActiveFAQItems(postId, apiPath) : acceptClickHandler()} text={'Yes!'} />
        <Button type={'button'} buttonType={'ButtonUncolored'} handler={() => closeCallback()} text={'Not yet'} />
        <span onClick={() => closeCallback()} className={classes.Close}/>
    </section> : '';
};

export default observer(BeforeCompletedMessage);
